// extracted by mini-css-extract-plugin
module.exports = {"message":"NewsletterSub_message__5bJnZ","error":"NewsletterSub_error__1NwW7","check":"NewsletterSub_check__2Q-ZR","submit":"NewsletterSub_submit__3NwmY"};